import { render, staticRenderFns } from "./widgetBarCompareChart.vue?vue&type=template&id=381085b6&scoped=true&"
import script from "./widgetBarCompareChart.vue?vue&type=script&lang=js&"
export * from "./widgetBarCompareChart.vue?vue&type=script&lang=js&"
import style0 from "./widgetBarCompareChart.vue?vue&type=style&index=0&id=381085b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381085b6",
  null
  
)

export default component.exports